import { type IAdvancedRichText } from '@framework/engine/inputs/rich-text-advanced/IAdvancedRichText.ts';
import { type IReference } from '@framework/engine/schema/expressions/references/IReference.ts';
import { type IInputWidget } from '@framework/engine/schema/widgets/repository/inputs/IInputWidget.ts';
import { type WidgetType } from '@framework/engine/schema/widgets/Widget.ts';

export const WidgetTypeCompetence = 'competence' as WidgetType.Competence;

/**
 * Seleziona competenze
 */
export interface ICompetenceWidget extends IInputWidget {
  id: string;
  type: WidgetType.Competence;
  label?: IAdvancedRichText;
  layout?: IInputWidget['layout'] & { hide?: boolean };
  sourceValueReference?: IReference | null;
  /**
   * Se true, la competenza indicata non sarà considerata come
   * competenza "primaria".
   */
  isExtraCompetence?: boolean;
  /**
   * Id del tipo di competenza secondaria. Ha senso solo quando
   * `isExtraCompetence` è true: identifica il tipo a cui associare la
   * competenza secondaria selezionata in fase di estrazione.
   */
  secondaryCompetenceTypeId?: string;
}
